export const integrationsCurrentsIntegrationsConfig = "/integrations/currents_integrations_config";
